import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { AuthGuard } from './auth/guard/auth.guard';
import { GuestGuard } from './auth/guard/guest.guard';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { PatientRegistrationComponent } from './pages/patient-registration/patient-registration.component';


export const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [ GuestGuard ]
	},
	{
		path: 'forgot-password',
		component: ForgotPasswordComponent,
		canActivate: [ GuestGuard ]
	},
	{
		path: 'reset-password',
		component: ResetPasswordComponent,
		canActivate: [ ]
	},
	// {
	// 	path: 'verify',
	// 	component: VerificationComponent,
	// 	canActivate: [ ]
	// },
	{ 
		path: '',
		loadChildren: () => import('../app/pages/pages.module').then(x=>x.PagesModule),
		canActivate: [ AuthGuard ]
	},
	{
		path: 'r',
		loadChildren: () => import("./pages//patient-registration/patient-registration.module").then(x=>x.PatientRegistrationModule),
		canActivate: [ ]
	},
	{ 
		path: '**', 
		component: PageNotFoundComponent
	}
];


@NgModule({
  imports: [
  	RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
